import {useState, useEffect} from 'react'
import {useDebounce, KTIcon} from '../../../../_metronic/helpers'

type DebounceSearchBoxProps = {
  onSearch: (value: string) => void
  searchDelay?: number
  placeholder?: string
  widthClass?: string
  style?: React.CSSProperties
}

const DebounceSearchBox = ({
  onSearch,
  searchDelay = 500,
  placeholder = 'Enter search value',
  widthClass = 'w-350px w-md-500px',
  style,
}: DebounceSearchBoxProps) => {
  const [value, setValue] = useState<string>('')
  const debouncedValue = useDebounce(value, searchDelay)

  useEffect(() => {
    onSearch(debouncedValue!)
  }, [debouncedValue, onSearch])

  return (
    <div className={`d-flex align-items-center position-relative my-2 ${widthClass}`} style={style}>
      <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6 text-gray-700' />
      <input
        type='text'
        className='form-control form-control-solid ps-16 rounded-pill py-3 bg-transparent border border-gray-600'
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
    </div>
  )
}

export default DebounceSearchBox
